import { Box, Typography } from '@mui/material';

import { User01Icon } from '@/components/icons/User01Icon';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { COLORS } from '@/styles/tokens/colors';

export interface ClientSetupIndividualIndicatorProps {
  variant: 'primary' | 'secondary';
}

/**
 * Icon + label marking a primary/secondary individual in the client-setup form.
 * Copied from the create-household modal's IndividualIndicator.
 */
export function ClientSetupIndividualIndicator({
  variant,
}: ClientSetupIndividualIndicatorProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
        minWidth: 80,
      }}
    >
      <User01Icon size={48} color={COLORS.NAVY[300]} strokeWidth={1.3} />
      <Typography
        variant="title-s"
        component="span"
        align="center"
        sx={{ maxWidth: 80 }}
      >
        {variant === 'primary' ? 'Primary individual' : 'Secondary individual'}
      </Typography>
      {variant === 'secondary' && (
        <Badge variant={BadgeVariants.Accent} display="Optional" />
      )}
    </Box>
  );
}
